export default __webpack_public_path__ + "static/media/erigon-circle.33e8d262.png";